export default __webpack_public_path__ + "static/media/redux.06ff246e.svg";